// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"4cbaef9f","55":"359f7c21","553":"4e2a1e8e","865":"9e2176ac"}[chunkId] + ".css";
};